import { Link as RouterLink } from 'preact-router'
import type { JSX } from 'preact'

/**
 * preact-router types `Link` as `JSX.HTMLAttributes<HTMLAnchorElement>`, which
 * omits anchor-specific props like `href`. Widen to the full intrinsic <a> props
 * so callers can pass href/children/className without type errors.
 */
type LinkProps = JSX.IntrinsicElements['a']

const Link = (props: LinkProps) => (
	<RouterLink {...(props as JSX.HTMLAttributes<HTMLAnchorElement>)} />
)

export default Link
